import { esES as coreEsES } from '@mui/material/locale'
import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import { esES as dataGridEsES } from '@mui/x-data-grid/locales'

import { components } from '@/theme/components'
import { palette, surfaces } from '@/theme/palette'
import { typography } from '@/theme/typography'

export const govioTheme = responsiveFontSizes(
  createTheme({
    palette,
    typography,
    shape: { borderRadius: 10 },
    spacing: 8,
    shadows: [
      'none',
      '0 1px 2px rgba(0,0,0,0.4)',
      '0 2px 4px rgba(0,0,0,0.4)',
      '0 4px 8px rgba(0,0,0,0.4)',
      '0 6px 12px rgba(0,0,0,0.4)',
      '0 8px 16px rgba(0,0,0,0.45)',
      '0 10px 20px rgba(0,0,0,0.45)',
      '0 12px 24px rgba(0,0,0,0.45)',
      '0 14px 28px rgba(0,0,0,0.5)',
      '0 16px 32px rgba(0,0,0,0.5)',
      '0 18px 36px rgba(0,0,0,0.5)',
      '0 20px 40px rgba(0,0,0,0.5)',
      '0 22px 44px rgba(0,0,0,0.5)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
      '0 24px 48px rgba(0,0,0,0.55)',
    ],
    components,
  },
  coreEsES,
  dataGridEsES,
  ),
)

export { surfaces }
